import React from "react";
import PropTypes from "prop-types";
import { device } from "~/utils/device";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import styled from "styled-components";

const UserSocialNetworks = ({ isSelf, profile, userDir }) => {
  const SocialWrapper = styled.section`
    display: inline-block;
    margin-right: 20px;
    @media ${device.laptop} {
      display: flex;
      align-items: center;
      margin-right: 0px;
      margin-bottom: 10px;
      float: left;
      width: 100%;
      a:first-of-type {
        width: 52px;
      }
    }
  `;

  return (
    <div>
      <div style={{ display: "flex" }}>
        <h3 style={{ marginBottom: "12px" }}>Social Networks</h3>

        {isSelf && (
          <div>
            <Link to={`/user/${userDir}/edit`}>
              <FontAwesomeIcon icon={["fas", "edit"]} style={{ marginLeft: "20px" }} />{" "}
            </Link>
          </div>
        )}
      </div>
      {(!profile.social || profile.social.length === 0) && <div style={{ fontSize: "12px" }}>Currently none</div>}

      {profile.social &&
        profile.social.map((sn) => {
          if (sn.network === "soundcloud")
            return (
              <SocialWrapper key={`${sn.network}-social`}>
                <a href={`https://soundcloud.com/${sn.profile_name}`} title="soundcloud" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={["fab", "soundcloud"]} style={{ marginRight: "5px", fontSize: "30px" }} />
                </a>
                <a href={`https://soundcloud.com/${sn.profile_name}`} title="soundcloud" target="_blank" rel="noopener noreferrer">
                  {sn.profile_name}
                </a>
              </SocialWrapper>
            );
          if (sn.network === "bandcamp")
            return (
              <SocialWrapper key={`${sn.network}-social`}>
                <a href={`https://bandcamp.com/${sn.profile_name}`} title="bandcamp" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={["fab", "bandcamp"]} style={{ marginRight: "5px", fontSize: "30px" }} />
                </a>
                <a href={`https://bandcamp.com/${sn.profile_name}`} title="bandcamp" target="_blank" rel="noopener noreferrer">
                  {sn.profile_name}
                </a>
              </SocialWrapper>
            );
          if (sn.network === "twitter")
            return (
              <SocialWrapper key={`${sn.network}-social`}>
                <a href={`https://twitter.com/${sn.profile_name}`} title="twitter" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={["fab", "twitter"]} style={{ marginRight: "5px", fontSize: "30px" }} />
                </a>
                <a href={`https://twitter.com/${sn.profile_name}`} title="twitter" target="_blank" rel="noopener noreferrer">
                  {sn.profile_name}
                </a>
              </SocialWrapper>
            );
          if (sn.network === "instagram")
            return (
              <SocialWrapper key={`${sn.network}-social`}>
                <a href={`https://instagram.com/${sn.profile_name}`} title="instagram" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={["fab", "instagram"]} style={{ marginRight: "5px", fontSize: "30px" }} />
                </a>
                <a href={`https://instagram.com/${sn.profile_name}`} title="instagram" target="_blank" rel="noopener noreferrer">
                  {sn.profile_name}
                </a>
              </SocialWrapper>
            );
          if (sn.network === "discogs")
            return (
              <SocialWrapper key={`${sn.network}-social`}>
                <a href={`https://discogs.com/user/${sn.profile_name}`} title="Discogs" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon="compact-disc" className="compact-disc" style={{ marginRight: "5px", fontSize: "30px" }} />
                </a>
                <a href={`https://discogs.com/user/${sn.profile_name}`} title="Discogs" target="_blank" rel="noopener noreferrer">
                  {sn.profile_name}
                </a>
              </SocialWrapper>
            );
        })}
    </div>
  );
};

UserSocialNetworks.propTypes = {
  isSelf: PropTypes.bool,
};

UserSocialNetworks.defaultProps = {
  isSelf: false,
};

export default UserSocialNetworks;
